import { parseMessage } from '@atcreate-inc/sigfox-decoder'
import { useEffect, useState } from 'react'
import { api } from '../services'
import { SigFoxMessageType, TMessageSigfoxOut } from '../common/enums'
import { SubLayout } from '../layouts/SubLayout'

interface Props {
  sigfoxId: string
}

export function ConfigMessagesViewer({ sigfoxId }: Props) {
  const [rawMessages, setRawMessages] = useState<any[]>([])

  useEffect(() => {
    if (sigfoxId !== '') {
      api.getRawConfigMessages(sigfoxId).then((response) => {
        const rawMessages = response.data.sort()
        setRawMessages(rawMessages)
      })
    }
  }, [sigfoxId]) // eslint-disable-line react-hooks/exhaustive-deps

  function determineMessageType(message: string): string {
    const byte = message.slice(0, 2)
    const messageType = parseInt(byte, 16)
    return SigFoxMessageType[messageType]
  }

  function sortData(data: TMessageSigfoxOut[]) {
    return data.sort((a, b) => b.MSG_RAW_ID - a.MSG_RAW_ID)
  }

  return (
    <SubLayout>
      <div>
        <h3>Config Message Viewer</h3>
        <div className={tailwind.rawMessages}>
          <table>
            <thead>
              <tr>
                <th className={tailwind.tableCellFirstColumn}>Raw Message Id</th>
                <th className={tailwind.tableCell}>Device Seq.No.</th>
                {/* <th className={tailwind.tableCell}>TIME</th> */}
                <th className={tailwind.tableCell}>Date Time</th>
                <th className={tailwind.tableCell}>MSG_CONTENT</th>
                <th className={tailwind.tableCell}>Message Type</th>
                <th className={tailwind.tableCell}>parse(MSG_CONTENT)</th>
              </tr>
            </thead>
            <tbody className={tailwind.tableOverflow}>
              {sortData(rawMessages).map((message: TMessageSigfoxOut, index: number) => {
                return (
                  <tr
                    key={index}
                    className={
                      (index % 2 ? '' : 'bg-slate-200 ') +
                      (determineMessageType(message.MSG_CONTENT) === 'TestMessage' ? 'text-red-700 text-bold' : '')
                    }
                  >
                    <td className={tailwind.tableCell}>{message.MSG_RAW_ID}</td>
                    <td className={tailwind.tableCellFirstColumn}>{message.SIGFOX_SNUM}</td>
                    {/* <td className={tailwind.tableCell}>{message.SIGFOX_TIME}</td> */}
                    <td className={tailwind.tableCellDateTime} style={{ minWidth: '200px' }}>
                      {new Date(message.SIGFOX_TIME * 1000).toLocaleString()}
                    </td>
                    <td className={tailwind.tableCell}>{message.MSG_CONTENT}</td>
                    <td className={tailwind.tableCell}>{determineMessageType(message.MSG_CONTENT)}</td>
                    <td className={tailwind.tableCellParsedMessage} style={{ width: '100px' }}>
                      {JSON.stringify(parseMessage(message.MSG_CONTENT), null, 2)}
                    </td>
                  </tr>
                )
              })}
            </tbody>
          </table>
        </div>
      </div>
    </SubLayout>
  )
}

const tailwind = {
  // row: 'mb-3 flex flex-row justify-between',
  row: 'mb-3',
  rawMessages: 'overflow overflow-y-auto',
  tableCell: 'pr-5',
  tableCellFirstColumn: 'pl-3 pr-5',
  tableCellDateTime: 'pr-5',
  tableOverflow: 'overflow overflow-y-auto',
  tableCellParsedMessage: 'pr-5',
}
